import React, { useState } from "react";
import sideimg from "../assets/imgs/Arise.png";

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          access_key: "35996e68-2628-4380-aeb5-8525bcebf205", // your Web3Forms access key
          name: `${formData.firstName} ${formData.lastName}`,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
          subject: "New Contact Form Submission",
          redirect: "", // optional: URL to redirect after submission
        })
      });

      const result = await response.json();

      if (result.success) {
        alert("Thank you! Your message has been sent.");
        setFormData({ firstName: "", lastName: "", email: "", phone: "", message: "" });
      } else {
        alert("Oops! Something went wrong. Please try again.");
        console.log(result);
      }
    } catch (error) {
      alert("Oops! Something went wrong. Please try again.");
      console.error(error);
    }
  };

  return (
    <section className="contact" id="contact">
      <div className="title scroll-effect">
        <h1 id="title">CONTACT</h1>
      </div>

      <div className="contact-container">
        <div className="hero-img">
          <img src={sideimg} alt="Contact Illustration" />
        </div>

        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-row scroll-effect">
            <div className="form-group">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-row scroll-effect">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-row full-width scroll-effect">
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
          </div>

          <div className="form-row full-width scroll-effect">
            <button type="submit" className="send-btn">Send</button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Contact;